import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';

let request = require('superagent-use')(require('superagent'));

export default class S3DownloadButton extends React.Component {
    constructor(props) {
        super(props);

        this.publicUrl = props.publicUrl;
        this.fileKey = props.fileKey;
    }

    static propType = {
        publicUrl: PropTypes.string,
        fileKey: PropTypes.string,
    };

    handleOnClick(proxy, event) {
        const fileUrl = this.publicUrl || `/s3/uploads/${this.fileKey}`;
        window.open(fileUrl, '_blank');
    }

    render() {
        const { fileKey, publicUrl, ...buttonProps } = this.props;
        return (
            <Button onClick={this.handleOnClick.bind(this)} {...buttonProps}>
                {this.props.children}
            </Button>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/s3-download-button.js